import classNames from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

function PinnedLabel({ label, isBreakingNews }) {
  const defaultText = i18next.t('Pinned');
  const text = label || defaultText;

  const pinnedLabelClasses = classNames(
    'lbp-card__pinned',
    {
      'lbp-card__pinned--breaking': isBreakingNews,
    },
  );

  return (
    <span
      className={pinnedLabelClasses}
      data-test="lbp-card__pinned"
    >
      {text}
    </span>
  );
}

PinnedLabel.propTypes = {
  label: PropTypes.string,
  isBreakingNews: PropTypes.bool,
};

PinnedLabel.defaultProps = {
  label: '',
  isBreakingNews: false,
};

export default PinnedLabel;
